import { Pencil, Loader2 } from 'lucide-react'

interface NameStepProps {
  name: string
  description: string
  onNameChange: (value: string) => void
  onDescriptionChange: (value: string) => void
  isGenerating: boolean
}

export function NameStep({ name, description, onNameChange, onDescriptionChange, isGenerating }: NameStepProps) {
  if (isGenerating) {
    return (
      <div className="flex flex-col items-center justify-center py-16">
        <Loader2 className="mb-6 h-10 w-10 animate-spin text-brand-500" />
        <p className="text-[15px] font-bold text-foreground/60">Generating a generic name for your series...</p>
      </div>
    )
  }

  return (
    <div>
      <h2 className="mb-2 text-3xl font-extrabold tracking-tight text-foreground">Name your series</h2>
      <p className="mb-8 text-[15px] font-medium text-foreground/60">
        We generated a name for you. Feel free to change it.
      </p>

      <div className="mb-8">
        <label className="mb-3 block text-[15px] font-bold text-foreground">Series name</label>
        <div className="relative">
          <input
            type="text"
            value={name}
            onChange={(e) => onNameChange(e.target.value)}
            className="w-full rounded-2xl border border-black/10 bg-white px-5 py-4 pr-12 text-xl font-extrabold text-foreground shadow-sm focus:border-brand-500 focus:outline-none focus:ring-2 focus:ring-brand-500/20"
            maxLength={200}
          />
          <Pencil className="absolute right-5 top-1/2 h-5 w-5 -translate-y-1/2 text-foreground/30" />
        </div>
      </div>

      <div>
        <label className="mb-3 block text-[15px] font-bold text-foreground">Description</label>
        <textarea
          value={description}
          onChange={(e) => onDescriptionChange(e.target.value)}
          className="w-full resize-none rounded-2xl border border-black/10 bg-white p-5 text-[15px] font-medium text-foreground shadow-sm placeholder:text-foreground/30 focus:border-brand-500 focus:outline-none focus:ring-2 focus:ring-brand-500/20"
          rows={4}
          maxLength={1000}
          placeholder="A short description for your RSS feed..."
        />
      </div>
    </div>
  )
}
